<template>
  <PageContent>
    <section>
      <div class="text-block-3">
        <p>To reach us, please write to:</p>
      </div>
      <div class="text-block-3">
        <p>
          <a href="mailto:contact@bismarckanalysis.com"
            >contact@bismarckanalysis.com</a
          >
        </p>
      </div>
    </section>
  </PageContent>
</template>

<script>
import PageContent from "./PageContent.vue";
export default {
  name: "Inquire",
  components: { PageContent },
  beforeCreate() {
    document.title = "Bismarck Analysis | Inquire";
  },
};
</script>

<style scoped>
section {
  display: flex;
  min-width: 100%;
  flex-wrap: wrap;
}

div {
  flex-grow: 1;
  min-width: 100%;
  clear: both;
}
</style>
